module.exports = __webpack_public_path__ + "img/blog4.305e543f.jpeg";